<div class="confirmpopup" id="vendor-confirmation-dialog-confirm-popup">
  <div mat-dialog-title id="vendor-confirmation-dialog-title-div">
    <label class="title" id="vendor-confirmation-dialog-title-label">Vendor: Confirmation</label>
  </div>
  <hr>
  <div mat-dialog-content id="vendor-confirmation-dialog-content-div">
    <p id="vendor-confirmation-dialog-content-p">{{confirmationVendorMsg}}</p>
  </div>
  <hr>
  <div mat-dialog-actions align="end" id="vendor-confirmation-dialog-actions-div">
    <button type="submit" mat-raised-button (click)="okClick()" color="primary" cdkFocusInitial matTooltip="Save Vendor" aria-label="Save Vendor" id="vendor-confirmation-dialog-ok-button">
      <mat-spinner color="accent" *ngIf="isLoadingSpinner" diameter="30" id="vendor-confirmation-dialog-spinner"></mat-spinner>
      <span *ngIf="!isLoadingSpinner" id="vendor-confirmation-dialog-ok-span">Ok</span>
    </button>
    <button mat-raised-button (click)="onNoClick()" color="warn" id="vendor-confirmation-dialog-no-button">No Thanks</button>
  </div>
</div>
